import UserError from './UserError.js'

export class CreateWhatsappIntentsUserError extends UserError {
  #message

  /**
   * @param {string} message
   * */
  static create({message}) {
    return new CreateWhatsappIntentsUserError({message})
  }

  constructor({message}) {
    super()
    this.#message = message
  }

  get message() {
    return this.#message
  }

  toJSON() {
    return {message: this.#message}
  }
}
